import { Controller } from "stimulus"

let previousImage;

export default class extends Controller {
  static targets = [ "imagePool", "image" ]

  connect() {
    this.startPolling()
  }

  disconnect() {
    clearTimeout(this.interval)
  }

  startPolling() {
    this.interval = setInterval(() => {
      this.replaceRandomImage()
    }, 3500)
  }

  replaceRandomImage() {
    var sample = arr => arr[Math.floor(Math.random() * arr.length)];

    if (previousImage === undefined) {
      var image = sample(this.imageTargets)
    } else {
      var image = sample(this.imageTargets.filter(e => e !== previousImage))
    }
    previousImage = image
    var replacement_url = sample(this.hiddenImages())

    image.classList.remove("transform", "scale-100", "scale-0")

    image.addEventListener('webkitTransitionEnd', function() {
      image.src = replacement_url
      image.classList.add("transform", "scale-100")
    }, false );

    image.classList.add("transform", "scale-0")
  }

  hiddenImages() {
    return this.imagePoolTargets.map(e => e.attributes.src.value).filter(x => !this.imageTargets.map(e => e.src).includes(x));
  }
}
